import React, { useState, useEffect } from 'react';

const HelensDiner = props => {
    const [phoneRinging, setPhoneRinging] = useState(false);

    useEffect(() => {
        if (phoneRinging) {
            props.audioController.playAudioByName('ringing_phone');
        } else {
            props.audioController.removeAudio('ringing_phone');
            props.audioController.playAudioByName('bite_to_eat');
            
            setTimeout(() => {
                props.onComplete();
            }, 5000)
        }
    }, [phoneRinging])

    useEffect(() => {
        return () => {
            props.audioController.removeAudio('ringing_phone');
        }
    }, [])

    const handlePhoneClick = () => {
        setPhoneRinging(false);
        // setTimeout(() => {
        //     // simulate phone call before we implement audio
        //     props.onComplete();
        // }, 5000)
    }



    return (
        <div className={`HelensDiner`}>
            <div className={`phone-screen ${!phoneRinging ? 'hidden' : ''}`} onClick={handlePhoneClick} />
            <div className={`truck-interior`} />
            <div className={`rain`} />
            <div className={`cup-illumination`} />
            <div className={`background`} />
        </div>
    )
}

export default HelensDiner